import TablePagination from '@mui/material/TablePagination'
import I18n from 'i18n-js'

/**
 * @typedef {Pick<import('@mui/material').TablePaginationProps, 'count' | 'onChangePage' | 'page' | 'rowsPerPage'>} PaginationProps
 */

/**
 * @type {React.FC<PaginationProps>}
 */
const Pagination = (props) => {
  return (
    <TablePagination
      component={'div'}
      count={props.count}
      onPageChange={(event, page) => {
        props.onChangePage(event, page + 1)
      }}
      page={props.page - 1}
      rowsPerPage={props.rowsPerPage}
      rowsPerPageOptions={[]}
      labelDisplayedRows={({ from, to, count }) =>
        I18n.t('shared.pagination', { from, to, count })
      }
    />
  )
}

export default Pagination
